import React, {Component} from 'react';
import {Button, Icon, Message} from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import Styles from '../ProveedorImport/ProveedorImport.module.css';

const normalize = value => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

class CatalogImport extends Component {
    state = {abierto: false, importando: false, resultado: null};
    fileInput = React.createRef();

    importar = async event => {
        const input = event.target;
        const file = input.files[0];
        if(!file) return;
        this.setState({importando: true, resultado: null});
        try {
            const workbook = XLSX.read(await file.arrayBuffer(), {type: 'array'});
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet, {header: 1, defval: ''});
            const expected = this.props.headers.map(normalize);
            const received = (rows[0] || []).slice(0, expected.length).map(normalize);
            if(expected.some((header, index) => received[index] !== header)) throw new Error(`Los encabezados no coinciden con la plantilla de ${this.props.label.toLowerCase()}.`);

            const existing = new Set((this.props.items || []).map(this.props.getKey).map(normalize));
            const fileKeys = new Set();
            const items = [];
            const invalidRows = [];
            let duplicates = 0;

            rows.slice(1).forEach((row, index) => {
                if(!String(row[0] || '').trim() || normalize(row[0]).startsWith('ejemplo:')) return;
                try {
                    const item = this.props.mapRow(row);
                    const key = normalize(this.props.getKey(item));
                    if(existing.has(key) || fileKeys.has(key)) {
                        duplicates++;
                        return;
                    }
                    fileKeys.add(key);
                    items.push(item);
                } catch(error) {
                    invalidRows.push(index + 2);
                }
            });

            if(invalidRows.length) throw new Error(`Corrige las filas ${invalidRows.join(', ')}: faltan campos obligatorios o contienen valores inválidos.`);
            if(!items.length && !duplicates) throw new Error(`El archivo no contiene ${this.props.label.toLowerCase()} para importar.`);
            await Promise.all(items.map(this.props.addItem));
            this.setState({resultado: {success: true, text: `${items.length} importados; ${duplicates} duplicados ignorados.`}});
        } catch(error) {
            this.setState({resultado: {success: false, text: error.message || 'No fue posible leer el archivo.'}});
        } finally {
            this.setState({importando: false});
            input.value = '';
        }
    };

    render() {
        return <div className={`${Styles.container} ${this.state.abierto ? Styles.containerOpen : ''}`}>
            {!this.state.abierto ?
                <Button type='button' basic onClick={() => this.setState({abierto: true, resultado: null})}><Icon name='upload' />Importar</Button>
            : <div className={Styles.panel}>
                <div className={Styles.panelHeader}>
                    <div>
                        <strong>Importar {this.props.label.toLowerCase()} desde Excel</strong>
                        <p>Descarga la plantilla o selecciona un archivo preparado.</p>
                    </div>
                    <Button type='button' basic onClick={() => this.setState({abierto: false, resultado: null})}><Icon name='arrow left' />Volver al formulario</Button>
                </div>
                <div className={Styles.options}>
                    <Button as='a' basic href={`/templates/${this.props.template}`} download={this.props.template}><Icon name='download' />Descargar plantilla</Button>
                    <Button type='button' basic loading={this.state.importando} onClick={() => this.fileInput.current.click()}><Icon name='file excel outline' />Seleccionar archivo</Button>
                    <input ref={this.fileInput} className={Styles.fileInput} type='file' accept='.xls,.xlsx' onChange={this.importar} />
                </div>
                {this.state.resultado ? <Message positive={this.state.resultado.success} negative={!this.state.resultado.success} size='small'>{this.state.resultado.text}</Message> : null}
            </div>}
        </div>;
    }
}

export default CatalogImport;
